import { render, staticRenderFns } from "./IcareYouth.vue?vue&type=template&id=3bcceb36&"
import script from "./IcareYouth.vue?vue&type=script&lang=js&"
export * from "./IcareYouth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports